import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'titleCase',standalone: false })
export class TitleCasePipe implements PipeTransform {
  transform(value: string | undefined): string {
    if (!value) return '';

    return value
      .toLowerCase()
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
}
